import { NextRouter, useRouter } from 'next/router';
import { useEffect } from 'react';

type Url = Parameters<NextRouter['replace']>[0];

export const useCanonicalUrl = (path: Url | null): void => {
  const router = useRouter();

  useEffect(() => {
    if (path) void router.replace(path);
  }, [path]);
};
